



























import { Component, Prop, Vue } from 'vue-property-decorator'
import RouteView from '@/components/layouts/RouteView.vue'
// @ts-ignore
import { mixinDevice } from '@/utils/mixin'

@Component({
	components: {
		RouteView,
	},
	mixins: [mixinDevice],
})
export default class UserLayout extends Vue {
	private mounted() {
		document.body.classList.add('userLayout')
	}
	private beforeDestroy() {
		document.body.classList.remove('userLayout')
	}
}
